export class Util {

    static getParameterByName(name : string) {
        let url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        results[2] = 'program-' + results[2];
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    static stringOrEmpty(str: string) {
        return str || '';
    }
}
